import { render, staticRenderFns } from "./AddPLPage.vue?vue&type=template&id=04d1817d&scoped=true&"
import script from "./AddPLPage.vue?vue&type=script&lang=js&"
export * from "./AddPLPage.vue?vue&type=script&lang=js&"
import style0 from "./AddPLPage.vue?vue&type=style&index=0&id=04d1817d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d1817d",
  null
  
)

export default component.exports